// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xD-z","smallCardRow":"yD-z","largeCardRow":"zD-z","productSearchRow":"AD-z","curatedRow":"BD-z"};